module.exports = __webpack_public_path__ + "assets/images/USD.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD.png
// module id = 1445
// module chunks = 1